import { render, staticRenderFns } from "./ItemGroupHeader.vue?vue&type=template&id=4b76677f&"
import script from "./ItemGroupHeader.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports